import { MailAttachmentPreview } from 'src/models/mail';

import { Callback } from 'src/util/query/models/Callback';

import { AddMailAttachmentPreviewPayload } from '../interfaces';

export class GetThePreviewForTheMailAttachmentCallback extends Callback<MailAttachmentPreview> {
	public constructor(
		private readonly aggregateId: string,
		private readonly filename: string,
		private readonly previewKey: string,
		private readonly addMailAttachmentPreview: (payload: AddMailAttachmentPreviewPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: MailAttachmentPreview): void => {
		this.addMailAttachmentPreview({
			aggregateId: this.aggregateId,
			filename: this.filename,
			payload: successResponse as Blob,
			previewKey: this.previewKey,
		});
	};
}
